import { render, staticRenderFns } from "./HomeHeadlines.vue?vue&type=template&id=70fbce6a&scoped=true"
import script from "./HomeHeadlines.vue?vue&type=script&lang=js"
export * from "./HomeHeadlines.vue?vue&type=script&lang=js"
import style0 from "./HomeHeadlines.vue?vue&type=style&index=0&id=70fbce6a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70fbce6a",
  null
  
)

export default component.exports